import {
  SET_DELIVERY_INFO,
  SET_LOADING,
  SET_ERROR,
} from "../action/actionTypes";

const initialState = {
  deliveryInfo: null,
  loading: false,
  error: null,
};

const deliveryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DELIVERY_INFO:
      return { ...state, deliveryInfo: action.payload, error: null };
    case SET_LOADING:
      return { ...state, loading: action.payload };
    case SET_ERROR:
      return { ...state, error: action.payload, deliveryInfo: null };
    default:
      return state;
  }
};

export default deliveryReducer;
